var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDutch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_17",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4356 9.00064C17.4356 10.1088 17.2173 11.2061 16.7932 12.23C16.3691 13.2538 15.7476 14.184 14.964 14.9676C14.1804 15.7512 13.2501 16.3728 12.2263 16.7969C11.2024 17.221 10.1051 17.4393 8.99694 17.4393C7.88877 17.4393 6.79144 17.221 5.76762 16.7969C4.7438 16.3728 3.81353 15.7512 3.02994 14.9676C2.24634 14.184 1.62475 13.2538 1.20067 12.23C0.776591 11.2061 0.558319 10.1088 0.558319 9.00064C0.558319 6.76257 1.44739 4.61618 3.02994 3.03363C4.61249 1.45108 6.75888 0.562012 8.99694 0.562012C11.235 0.562012 13.3814 1.45108 14.964 3.03363C16.5465 4.61618 17.4356 6.76257 17.4356 9.00064Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 17.4375V11.8125H0.5625V17.4375H17.4375Z",
    fill: "#2B4896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 11.8125V6.1875H0.5625V11.8125H17.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 6.1875V0.5625H0.5625V6.1875H17.4375Z",
    fill: "#C0392B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDutch);
export default __webpack_public_path__ + "static/media/dutch.c83eec3e7bae46b1003b4e3e12cd16eb.svg";
export { ForwardRef as ReactComponent };